import { gql } from "@apollo/client";

export const GET_RECEIPT_PROCESSING_STATUS = gql`
  query receiptProcessingStatus($id: ID!) {
    receiptDetail(id: $id) {
      id
      processingStatus
    }
  }
`;

// The receipt library; the server scopes by role, and `mine` narrows it to the viewer.
export const GET_RECEIPTS = gql`
  query receipts(
    $first: Int
    $after: String
    $amount: AmountQuery
    $startDate: Float
    $endDate: Float
    $search: String
    $receiptLibraryFilter: ReceiptLibraryFilter
    $userId: ID
    $mine: Boolean
  ) {
    receipts(
      first: $first
      after: $after
      amount: $amount
      startDate: $startDate
      endDate: $endDate
      search: $search
      receiptLibraryFilter: $receiptLibraryFilter
      userId: $userId
      mine: $mine
    ) {
      edges {
        cursor
        node {
          id
          companyName
          amount
          transactionDate
          isMatchTransaction
          processingStatus
          currency
          assets {
            assetUrl
            id
            extension
            filename
          }
          user {
            id
            firstName
            lastName
            profilePicUrl
          }
          createdAt
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        total
      }
    }
  }
`;

// Single receipt detail by ID

export const GET_RECEIPT_DETAIL = gql`
  query receiptDetail($id: ID!) {
    receiptDetail(id: $id) {
      id
      companyName
      createdAt
      receiptUrl
      address {
        address1
        address2
        city
        state
        zipcode
        country
      }
      units {
        originalName
        name
        description
        quantity
        price
        productUrl
      }
      salesTax
      displaySalesTax
      amount
      receiptNumber
      isMatchTransaction
      processingStatus
      currency
      transactionDate
      transactionId
      user {
        id
        firstName
        lastName
        email
        profilePicUrl
      }
      assets {
        assetUrl
        id
        extension
        filename
      }
    }
  }
`;

export const UPDATE_RECEIPT = gql`
  mutation updateReceiptDetail($id: ID!, $input: ReceiptDetailInput!) {
    updateReceiptDetail(id: $id, input: $input) {
      companyName
      amount
      transactionDate
      isMatchTransaction
      processingStatus
      transactionId
    }
  }
`;

export const CONNECT_RECEIPT = gql`
  mutation connectReceiptDetail($receiptId: ID!, $transactionId: ID!) {
    connectReceiptDetail(receiptId: $receiptId, transactionId: $transactionId) {
      companyName
      amount
      transactionDate
      isMatchTransaction
      processingStatus
      transactionId
    }
  }
`;

// Delete a single image from a receipt
// Delete a receipt
export const DELETE_RECEIPT = gql`
  mutation deleteReceiptDetail($id: ID!) {
    deleteReceiptDetail(id: $id) {
      id
    }
  }
`;
